import { DocumentoFiscalStatus } from "../types";

export const getStatusConfig = (status: DocumentoFiscalStatus | null | undefined) => {
  switch (status.toLowerCase()) {
    case 'pendente':
      return {
        label: 'Pendente',
        className:
          'bg-yellow-50 text-yellow-800 border border-yellow-200 dark:bg-yellow-900/40 dark:text-yellow-200 dark:border-yellow-800'
      };
    case 'deferido':
      return {
        label: 'Deferido',
        className:
          'bg-green-50 text-green-800 border border-green-200 dark:bg-green-900/30 dark:text-green-200 dark:border-green-800'
      };
    case 'indeferido':
      return {
        label: 'Indeferido',
        className:
          'bg-red-50 text-red-800 border border-red-200 dark:bg-red-900/30 dark:text-red-200 dark:border-red-700'
      };
    default:
      return {
        label: '—',
        className:
          'bg-gray-50 text-gray-700 border border-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-700'
      };
  }
}
